import React, {useRef} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useNavigate, useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import './FileScheduler.scss'

const FileSchedulerReview = ({data, handleSubmit, setStep}: any) => {
  return (
    <div className='col-md-8 bg-white rounded'>
      <div className='p-8'>
        <div className=''>
          <h2 className='msg_title'>Confirm & Send</h2>
          <p className='msg_desc'>If you still need more info, visit our</p>
          {/* TODO: Handle when balance is low */}
          {/* <div className='col-xl-8 col-sm-8 col-md-8 col-lg-8 mb-10 alert alert-danger'>
              Your balance is insufficient to send this message. Please contact your account
              manager.
            </div> */}
        </div>
        <div className='card bg-secondary p-8'>
          <div>
            <h2 className='mb-0 mt-0 pb-3'>Summary</h2>
            <div className='row'>
              <div className='col-sm-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/communication\com005.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div>
                  <span>
                    <strong>{data?.contacts}</strong>
                  </span>
                  <p className='text-muted'>Recipients</p>
                </div>
              </div>
              <div className='col-sm-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen028.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div>
                  <span>
                    <strong>{data?.deductibleCredits}</strong>
                  </span>
                  <p className='text-muted'>Credits required</p>
                </div>
              </div>
              <div className='col-sm-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/general/image 222.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div>
                  <span>
                    <strong>{data?.totalCharacters}</strong>
                  </span>
                  <p className='text-muted'>Total characters</p>
                </div>
              </div>

              <div className='col-sm-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/general/image 222.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div>
                  <span>
                    <strong>{data?.messageCount}</strong>
                  </span>
                  <p className='text-muted'>Total Message Count</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-between' style={{maxWidth: '528px'}}>
        <button
          className='btn mx-8 btn-secondary'
          onClick={() => setStep('form')}
        >
          Back
        </button>
        <button className='btn msg-primary-btn send btn-primary' onClick={handleSubmit}>
          Send now
        </button>
      </div>
    </div>
  )
}

export default FileSchedulerReview
